import { colors } from '@hazadapt-git/public-core-base'
import { Box, Button, Stack, Typography } from '@mui/material'
import React, { FC } from 'react'
import { FaApple, FaGooglePlay } from 'react-icons/fa'
import { IoShareSocialOutline } from 'react-icons/io5'
import { logEvent } from '../../lib/utils'

interface ContributeSupportLinksBlockProps {
    text: string
}

const SHARE_LINK = 'https://get.hazadapt.com/'

export const ContributeSupportLinksBlock: FC<ContributeSupportLinksBlockProps> = ({
    text,
}: ContributeSupportLinksBlockProps) => {
    const [copied, setCopied] = React.useState<boolean>(false)

    const onCopyShareLink = async () => {
        try {
            await navigator.clipboard.writeText(SHARE_LINK)
            setCopied(true)
            logEvent('SHARE_HAZADAPT', {
                origin: `${window.location.origin}${window.location.pathname}`,
            })
            window.setTimeout(() => setCopied(false), 2000)
        } catch (err) {
            console.error('Unable to copy share link.', err)
        }
    }

    return (
        <Box
            sx={{
                border: '1px solid',
                borderColor: 'divider',
                borderRadius: 1,
                p: 2,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
            }}
        >
            <Typography
                variant="body1"
                sx={{ color: colors.grays.THUNDERCLOUD }}
            >
                {text}
            </Typography>
            <Stack direction="row" spacing={1.5} mt={1.5} flexWrap="wrap" useFlexGap>
                <Button
                    component="a"
                    href="https://apps.apple.com/us/app/hazadapt-emergency-safety-app/id1548019714?action=write-review"
                    target="_blank"
                    rel="noopener noreferrer"
                    variant="outlined"
                    startIcon={<FaApple />}
                >
                    Leave an Apple review
                </Button>
                <Button
                    component="a"
                    href="https://play.google.com/store/apps/details?id=com.hazadapt.hazadapt&showAllReviews=true"
                    target="_blank"
                    rel="noopener noreferrer"
                    variant="outlined"
                    startIcon={<FaGooglePlay />}
                >
                    Leave a Google review
                </Button>
                <Button
                    onClick={() => void onCopyShareLink()}
                    variant="outlined"
                    startIcon={<IoShareSocialOutline />}
                >
                    {copied ? 'Copied!' : 'Copy Share Link'}
                </Button>
            </Stack>
        </Box>
    )
}
